export default {
  AC: 'Ascension',
  AD: 'Andorra',
  AE: 'Vereinigte Arabische Emirate',
  AF: 'Afghanistan',
  AG: 'Antigua und Barbuda',
  AI: 'Anguilla',
  AL: 'Albanien',
  AM: 'Armenien',
  AN: 'Niederländische Antillen',
  AO: 'Angola',
  AQ: 'Antarktis',
  AR: 'Argentinien',
  AS: 'Amerikanisch-Samoa',
  AT: 'Österreich',
  AU: 'Australien',
  AW: 'Aruba',
  AX: 'Åland-Inseln',
  AZ: 'Aserbaidschan',
  BA: 'Bosnien und Herzegowina',
  BB: 'Barbados',
  BD: 'Bangladesch',
  BE: 'Belgien',
  BF: 'Burkina Faso',
  BG: 'Bulgarien',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint-Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivien',
  BQ: 'Karibische Niederlande',
  BR: 'Brasilien',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvetinsel',
  BW: 'Botswana',
  BY: 'Weißrussland',
  BZ: 'Belize',
  CA: 'Kanada',
  CC: 'Kokosinseln (Keelinginseln)',
  CD: 'Kongo, Demokratische Republik',
  CF: 'Zentralafrikanische Republik',
  CG: 'Kongo, Republik',
  CH: 'Schweiz',
  CI: 'Elfenbeinküste',
  CK: 'Cook-Inseln',
  CL: 'Chile',
  CM: 'Kamerun',
  CN: 'China',
  CO: 'Kolumbien',
  CP: 'Clippertoninsel',
  CR: 'Costa Rica',
  CU: 'Kuba',
  CV: 'Kap Verde',
  CW: 'Curaçao',
  CX: 'Weihnachtsinsel',
  CY: 'Zypern',
  CZ: 'Tschechische Republik',
  DE: 'Deutschland',
  DG: 'Diego Garcia',
  DJ: 'Dschibuti',
  DK: 'Dänemark',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  DZ: 'Algerien',
  EA: 'Ceuta und Melilla',
  EC: 'Ecuador',
  EE: 'Estland',
  EG: 'Ägypten',
  EH: 'Westsahara',
  ER: 'Eritrea',
  ES: 'Spanien',
  ET: 'Äthiopien',
  EU: 'Europäische Union',
  FI: 'Finnland',
  FJ: 'Fidschi',
  FK: 'Falklandinseln',
  FM: 'Mikronesien',
  FO: 'Färöer-Inseln',
  FR: 'Frankreich',
  GA: 'Gabon',
  GB: 'Vereinigtes Königreich',
  GD: 'Grenada',
  GE: 'Georgien',
  GF: 'Französisch-Guayana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Grönland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Äquatorialguinea',
  GR: 'Griechenland',
  GS: 'Südgeorgien und die südlichen Sandwichinseln',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard und McDonald Inseln',
  HN: 'Honduras',
  HR: 'Kroatien',
  HT: 'Haiti',
  HU: 'Ungarn',
  IC: 'Kanarische Inseln',
  ID: 'Indonesien',
  IE: 'Irland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'Indien',
  IO: 'Britisches Territorium im Indischen Ozean',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'Island',
  IT: 'Italien',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenia',
  KG: 'Kirgisistan',
  KH: 'Kambodscha ',
  KI: 'Kiribati',
  KM: 'Komoren',
  KN: 'St. Kitts und Nevis',
  KP: 'Nordkorea',
  KR: 'Südkorea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kasachstan',
  LA: 'Laos',
  LB: 'Libanon',
  LC: 'St. Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Litauen',
  LU: 'Luxemburg',
  LV: 'Lettland',
  LY: 'Libyen',
  MA: 'Marokko',
  MC: 'Monaco',
  MD: 'Republik Moldau',
  ME: 'Montenegro',
  MF: 'St. Martin’s Island',
  MG: 'Madagaskar',
  MH: 'Marshallinseln',
  MK: 'Republik Mazedonien (EJRM)',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolei',
  MO: 'Macau',
  MP: 'Nördliche Marianen',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Malediven',
  MW: 'Malawi',
  MX: 'Mexiko',
  MY: 'Malaysia',
  MZ: 'Mosambik',
  NA: 'Namibia',
  NC: 'Neukaledonien',
  NE: 'Niger',
  NF: 'Norfolk-Insel',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Niederlande',
  NO: 'Norwegen',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'Neuseeland',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Französisch-Polynesien',
  PG: 'Papua-Neuguinea',
  PH: 'Philippinen',
  PK: 'Pakistan',
  PL: 'Polen',
  PM: 'St. Pierre und Miquelon',
  PN: 'Pitcairninseln',
  PR: 'Puerto Rico',
  PS: 'Palästinensische Autonomiegebiete',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Katar',
  QO: 'Amerikanisch-Ozeanien',
  RE: 'Réunion',
  RO: 'Rumänien',
  RS: 'Serbien',
  RU: 'Russland',
  RW: 'Ruanda',
  SA: 'Saudi-Arabien',
  SB: 'Salomonen',
  SC: 'Seychellen',
  SD: 'Sudan',
  SE: 'Schweden',
  SG: 'Singapur',
  SH: 'St. Helena',
  SI: 'Slowenien',
  SJ: 'Svalbard und Jan Mayen',
  SK: 'Slowakei',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Surinam',
  SS: 'Südsudan',
  ST: 'São Tomé und Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syrien',
  SZ: 'Swasiland',
  TA: 'Tristan da Cunha',
  TC: 'Turks- und Caicosinseln',
  TD: 'Tschad',
  TF: 'Französische Südgebiete',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tadschikistan',
  TK: 'Tokelau',
  TL: 'Osttimor',
  TM: 'Turkmenistan',
  TN: 'Tunesien',
  TO: 'Tonga',
  TR: 'Türkei',
  TT: 'Trinidad und Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tansania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'Amerikanische Überseeinseln',
  US: 'Vereinigte Staaten',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VA: 'Vatikanstadt',
  VC: 'St. Vincent und die Grenadinen',
  VE: 'Venezuela',
  VG: 'Britische Jungferninseln',
  VI: 'US-Jungferninseln',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis und Futuna',
  WS: 'Samoa',
  YE: 'Jemen',
  YT: 'Mayotte',
  ZA: 'Südafrika',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
  ZZ: 'Unbekannte Region',
};
